class AnimSprite {
	constructor(name, fps, frames) {
		this.name = name;
        this.fps = fps;
		this.frames = frames;
	}
}

export default AnimSprite;